(() => {
'use strict';
class ProductFinishes extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-finish-value]');
      if (!button) return;
      const input = document.querySelector(`variant-picker [data-option-value-id="${CSS.escape(button.dataset.finishValue)}"]`);
      if (!input) return;
      input.checked = true;
      input.dispatchEvent(new CustomEvent('change', { bubbles: true, detail: { focusTargetId: button.id } }));
    }, { signal: this.controller.signal });
  }
  disconnectedCallback() { this.controller?.abort(); }
}
if (!customElements.get('product-finishes')) customElements.define('product-finishes', ProductFinishes);

})();
